import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { FiatActionButton } from './FiatActionButton'
import { FiatReceipt } from './FiatReceipt'
import { FiatSubmissionIndicator } from './FiatSubmissionIndicator'
import { useKycCompletionHold } from './useKycCompletion'

export interface FiatKycOutcomeScreenProps {
  outcome: 'review' | 'hold' | 'restricted'
  /**
   * The verdict is withheld for now: the screen wears the hold's wording and
   * spins where its action goes. What was sent has landed, and the answer then
   * arrives on a screen the buyer is already reading.
   */
  pending?: boolean
  recovery?: { label: string; onPress: () => void }
  retryDetail?: string
  onContinue: () => void
}

/**
 * The acknowledgement as the flow shows it, wait and all.
 *
 * - The wait starts here, on mount, so it is the screen's own: the verdict is
 *   often decided while another screen still owns the frame.
 */
export function FiatKycCompletion(
  props: Omit<FiatKycOutcomeScreenProps, 'pending'>,
) {
  const held = useKycCompletionHold()
  return <FiatKycOutcomeScreen {...props} pending={held} />
}

export function FiatKycOutcomeScreen({
  outcome,
  pending = false,
  recovery,
  retryDetail,
  onContinue,
}: FiatKycOutcomeScreenProps) {
  const { t } = useFunkitTranslation()
  const restricted = !pending && outcome === 'restricted'
  const title = () => {
    if (pending || outcome === 'hold') {
      return t('fiat.kycHoldTitle')
    }
    if (restricted) {
      return t('fiat.kycRestrictedTitle')
    }
    return t('fiat.kycReviewTitle')
  }
  return (
    <FiatReceipt
      restricted={restricted}
      title={title()}
      supportLabel={
        restricted ? t('fiat.kycGetHelpSupport') : t('fiat.kycAnyQuestions')
      }
      detail={pending ? undefined : retryDetail}
    >
      {pending ? <FiatSubmissionIndicator /> : null}
      {!pending && recovery !== undefined ? (
        <FiatActionButton label={recovery.label} onPress={recovery.onPress} />
      ) : null}
      {pending ? null : (
        <FiatActionButton label={t('common.continue')} onPress={onContinue} />
      )}
    </FiatReceipt>
  )
}
